import { PropsWithChildren } from "react";

import { useUser } from "@/hooks/useUser";

import styles from "./Quote.module.css";

const QUOTE_STYLES = {
  sv: ["”", "”"], // [start, end]
  en: ["“", "”"],
};

const Quote: React.FC<PropsWithChildren> = ({ children }) => {
  const { data: userData } = useUser();
  const { language = "sv" } = userData?.ok ? userData.data : {};
  const [start, end] = QUOTE_STYLES[language] || QUOTE_STYLES.sv;

  return (
    <>
      <span className={styles.root}>{start}</span>
      {children}
      <span className={styles.root}>{end}</span>
    </>
  );
};

export default Quote;
